export default class PictureTextElementTile {
    readonly position: number;
    readonly subline: string;
    readonly id: string;
    readonly labels: { [key: string]: string[] };
    readonly tileDom: Element;

    constructor(tileDom: Element, position: number, tileTrackingFeatureId: string) {
        this.subline = tileDom.getAttribute("footer-headline") || "";
        this.position = position;
        this.tileDom = tileDom;
        this.id = tileTrackingFeatureId;
        this.labels = {
            promo_Content: [this.subline],
            promo_Source: ["manual"],
        };
        tileDom.setAttribute("data-tile-position", position.toString())
    }
}